<!-- 直采特价弹框 -->
<template>
    <el-dialog custom-class="outDialog" center :visible.sync="dialogVisible" width="34%" :show-close="false"
        :before-close="handleClose">
        <div class="header">
            <span>{{ titieMap[state] }} 直采特价</span>
        </div>
        <main class="main">
            <hotelDirectMining v-if="state === 0"></hotelDirectMining>
            <siteDirectMining v-if="state === 1"></siteDirectMining>
        </main>
        <span slot="footer" class="dialog-footer">
            <el-button class="saveBtn" @click="sendPopup">快马加鞭 让资源方速速给我个报价</el-button>
        </span>
        <directSendPopup :state="state" ref="directSendPopup"></directSendPopup>
    </el-dialog>
</template>

<script>
import hotelDirectMining from './directPurchassSpecialchild/hotelDirectMining.vue';
import siteDirectMining from './directPurchassSpecialchild/siteDirectMining.vue';
import directSendPopup from './directSendPopup.vue'
export default {
    components: {
        hotelDirectMining,
        siteDirectMining,
        directSendPopup
    },
    data() {
        return {
            dialogVisible: false,
            state: 0,
            titieMap: {
                '0': '酒店',
                '1': '会议/活动场地'
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        init(item) {
            this.state = item.state
            this.dialogVisible = true
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        //打开发送弹框
        sendPopup() {
            this.$refs.directSendPopup.init()
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .outDialog {
    box-shadow: 0px 0px 13px 9px rgba(0, 0, 0, 0.4);
}

/deep/ .el-dialog__body {
    padding: 0;
}

/deep/ .el-dialog__header {
    padding-top: 0;
}

/deep/ .outDialog .el-dialog__footer {
    border-top: 3px dotted #DB4E1A;
    padding-top: 0.25rem;
    padding-bottom: 0.4rem;
}

.header {
    padding: 0.25rem;
    font-size: 0.2rem;
    color: rgba(16, 16, 16, 1);
    font-family: SourceHanSansSC-regular;
}

.main {
    padding: 0 0.25rem 0.25rem 0.25rem;
}

.saveBtn {
    width: 446px;
    background-color: rgba(255, 255, 255, 1);
    text-align: center;
    box-shadow: 1px 1px 3px 2px rgba(0, 0, 0, 0.4);
    border-radius: 8rpx;
    background-color: rgba(219, 78, 26, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 0.2rem;
    text-align: center;
    box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.4);
    font-family: PingFang SC;
    border: 1px solid rgba(224, 224, 224, 1);
}
</style>